var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoHeartGreyOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23333 2.50004C7.93 2.50087 9.3775 5.40921 10 6.69254C10.625 5.40337 12.0575 2.50837 14.7717 2.50837C16.4867 2.50837 18.3333 3.59921 18.3333 5.99337C18.3333 8.86171 14.38 12.5359 10 16.8267C5.61833 12.5342 1.66667 8.86087 1.66667 5.99337C1.66667 3.76337 3.30417 2.49921 5.23333 2.50004ZM5.23417 0.833374C2.58167 0.833374 0 2.65587 0 5.99337C0 9.87754 4.64167 13.8492 10 19.1667C15.3583 13.8492 20 9.87754 20 5.99337C20 2.65087 17.4192 0.841707 14.7717 0.841707C12.935 0.841707 11.0667 1.71004 10 3.54004C8.92917 1.70171 7.065 0.833374 5.23417 0.833374Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHeartGreyOutline);
export default __webpack_public_path__ + "static/media/ico-heart-grey-outline.b2a68e32bc002b33ba2b284eaa35ebb2.svg";
export { ForwardRef as ReactComponent };